/**
 * TemplateVariable entity class
 */

/**
 * TemplateVariableFactory
 * returns TemplateVariable entity class
 *
 * @class TemplateVariableFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.TemplateVariable} class
 *
 * @ngdoc factory
 * @name mwApp.factory:TemplateVariableFactory
 */
/* @ngInject */
export default function TemplateVariableFactory (
  $http,
  Entity,
  alertLiteSvc
) {
  /* === TemplateVariable class === */

  /**
   * TemplateVariable model
   *
   * @class TemplateVariable
   * @classdesc TemplateVariable model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @return {models.TemplateVariable} TemplateVariable entity
   */
  function TemplateVariable () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  TemplateVariable.prototype = Object.create(Entity.prototype)
  TemplateVariable.prototype.constructor = TemplateVariable

  /* === TemplateVariable instance methods & fields === */

  Object.assign(TemplateVariable.prototype, {

    /**
     * instance fields
     *
     * @memberof models.TemplateVariable#
     * @type {Object}
     */
    _fields: {
      id: Number,
      defaultValue: String,
      name: String,
      overrides: [{ target: { entityName: String, entityId: Number, entityType: String }, value: String }],
      useDefaultValue: Boolean,
      value: String
    },

    /**
     * url template
     *
     * @memberof models.TemplateVariable#
     * @type {String}
     */
    _publicUrlTemplate: 'extensions/variables/{{::id}}',

    /**
     * url template
     *
     * @memberof models.TemplateVariable#
     * @type {String}
     */
    _urlTemplate: 'api/extensions/variables/{{::id}}'

  })

  /* === TemplateVariable static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(TemplateVariable, Entity)
  TemplateVariable._name = 'TemplateVariable'
  TemplateVariable.init()

  /**
   * Get available template variable values for a specific entity
   *
   * @memberof models.TemplateVariable
   * @param {string} entityType - Type of entity (e.g., 'network', 'organization')
   * @param {number} entityId - ID of the entity
   * @returns {Promise<Object>} Promise that resolves with template variable values
   */
  TemplateVariable.getTemplatesByEntity = function (entityId, entityType = 'NETWORK') {
    const url = `api/variables/values/${entityType}/${entityId}`
    return $http.get(url)
      .then(response => response.data.payload.map(item => new TemplateVariable(item)))
      .catch(() => {
        alertLiteSvc.alertError('Failed to load template variable values')
      })
  }

  TemplateVariable.saveTemplatesByEntity = function (templates, entityId, entityType = 'NETWORK') {
    const url = `api/variables/values/${entityType}/${entityId}`

    return $http.put(url, templates)
  }

  TemplateVariable.loadAllVariables = function () {
    const url = 'api/variables'

    return $http.get(url)
      .then(response => response.data.payload.CONTENT_MEDIA_HOST)
      .catch(() => {
        alertLiteSvc.alertError('Failed to load template variables')
      })
  }

  return TemplateVariable
}
